/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import CloseIcon from '@mui/icons-material/Close';
import { Grid } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { feedActionContext } from '../../..';
import '../../../../../UiStyles/FilePlayer/styles.css';
import Comments from '../../Reusable/Comments';
import FeedBody from '../FeedCards/Card/FeedBody';
import FeedFooter from '../FeedCards/Card/FeedFooter';
import FeedHeader from '../FeedCards/Card/FeedHeader';
import MediaPreviewNew from '../FeedCards/FeedMediaView/MediaPreviewNew';
// import '../styles.css';
// import SharePost from './SharePost';
// import CommentsBlock from '../Comments';
// import LikesViewPopup from '../../../components/Common/Feed/LikesViewPopup';

// full screen view of feed when clicked on media
const FeedFullView = ({ feedId, handleClosePost, feed, setViewData, Like, currentIndex, getLatestFeed, mediaData, setCurrentIndex, handleUpdateFeed, from, isInViewPort, openVideo }) =>
{
	console.log(feed, 'feed::::::::oooo');
	const [ openShare, setOpenShare ] = useState({
		open : false,
		item : {}
	});
	// const { language } = useContext(LanguageContext);
	const { type } = useParams();
	const { feedCardActn, setFeedCardActn, handleFeedAction, feedAction } = useContext(feedActionContext);
	const isCommentOpened = feedCardActn?.[0] === 'comments' && feedAction?.is_full_screen;
	const [ isVideoPlaying, setIsVideoPlaying ] = useState<boolean>(false);
	const isFeedPendingOrRejected = [ 'pending', 'rejected' ].includes(feed?.status);
	const hideFooter = [ 'repost' ].includes(from) || isFeedPendingOrRejected;

	console.log(isCommentOpened, 'isCommentOpened', feedCardActn, 'feedCardActnfeedCardActn**', type, 'type');
	const openComment = Array.isArray(feedCardActn) && feedCardActn?.length > 0 && isCommentOpened && type !== 'celebrationevents';

	const handleClose = () =>
	{
		handleFeedAction('remove', 'is_full_screen');
		setFeedCardActn([]);
		handleClosePost();
	};

	return (
		<div className={`flexCol fxdImgPlayerCntr ${feed !== null ? 'showPlayerCntnr' : ''}`} style={{ display: currentIndex === 0 && !openVideo ? 'none' : undefined }}>
			<div className={`resPColRow scrollY fullHeight ${!openShare && !openComment && 'mediaSliderMain'}`}>
				<div className='postImage scrollY'>
					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }} className='flexInline slidePostBtns slideCloseBtn alignCntr justifyCntr' onClick={handleClose}>
						<CloseIcon />
					</button>
					<MediaPreviewNew
						openVideo={openVideo}
						mediaList={mediaData}
						currentIndex={currentIndex}
						setCurrentIndex={setCurrentIndex}
						setIsVideoPlaying={setIsVideoPlaying}
					/>
				</div>
				{currentIndex >= 0 && openVideo && <div style={{ backgroundColor: '#fff' }} className='postCntnt scrollY'>
					<div className='flexCol pdngXS'>
						<Grid item xs={12}>
							<FeedHeader
								feed={feed}
								delCloseGetApi={() => {}}
								handleUpdateFeed={handleUpdateFeed}
								// index={index}
								index={0}
								from='repost'
							/>
						</Grid>
						<Grid item xs={12}>
							<FeedBody
								feed={feed}
								type={type}
								handleUpdateFeed={() => {}}
								hideMedia
							/>
						</Grid>
						{window.location.pathname.includes('news') && !hideFooter &&
						<div className='flexAutoCol'>
							<div className='flexRow brdrTSM pdngSM mrgnTXS'>
								<Grid item xs={12} >
									<FeedFooter
										from={from}
										key={[ feed?._id, feed?.repostCount ]}
										feed={feed}
										eachType={feed.type}
										feedId={feed?._id}
										requestT={'fullscreen'}
										delCloseGetApi={() => {}}
										isVideoPlaying={isVideoPlaying}

									/>
								</Grid>
							</div>
						</div>
						}
					</div>
				</div>}
			</div>
			{currentIndex >= 0 && openVideo && <div className={openComment ? 'flexCol fxdCommentSlider slideIn' : 'fxdCommentSlider'} >
				{openComment && <Comments from='feeds' />}
			</div>}
		</div>
	);
};

export default FeedFullView;